import { render } from "./AddBonAncienPage.vue?vue&type=template&id=2bfafba3&ts=true"
import script from "./AddBonAncienPage.vue?vue&type=script&lang=ts"
export * from "./AddBonAncienPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__